export const API_ROOT = 'https://api-live.its-live.net/v1';

export const SESSION_UPDATE = 'sessionUpdate';
export const RACE_CONTROL_MESSAGE = 'raceControlMessage';
export const STATE_UPDATE = 'stateUpdate';
export const CONFIG_UPDATE = 'configUpdate';
